import { useConfigProvider } from '@/lib/context';
import React, { useState } from 'react';
import Vimeo from '@u-wave/react-vimeo';
import PietraModal from '../PietraModal';
import './index.less';

interface IProps {
  visible: boolean;
  videoId: number;
  onClose: () => void;
  autoplay?: boolean;
}

const VimeoDialog = ({ videoId, visible, autoplay, onClose }: IProps) => {
  const [paused, setPaused] = useState<boolean>(false);

  const { isMobile } = useConfigProvider();

  return (
    <PietraModal
      className="vimeo-dialog"
      visible={visible}
      close={() => {
        setPaused(true);
        onClose();
      }}
    >
      <div className="inner">
        {videoId && visible && (
          // @ts-ignore
          <Vimeo
            autoplay={autoplay && visible}
            video={videoId}
            width={isMobile ? 320 : 800}
            showTitle={false}
            paused={paused}
            onPlay={() => {
              setPaused(false);
            }}
            onPause={() => {
              setPaused(true);
            }}
          />
        )}
      </div>
    </PietraModal>
  );
};

export default VimeoDialog;
